/**
 * frontend/src/utils/errorHandling.js
 *
 * Utility functions for handling and formatting errors from the API.
 */

/**
 * Format error response from the API into a user-friendly message.
 * Handles both FastAPI validation errors (array of objects) and string errors.
 *
 * @param {Object} err - The error object from axios
 * @param {string} defaultMessage - Default message if error format is unknown
 * @returns {string} Formatted error message
 */
export const formatErrorMessage = (err, defaultMessage = 'An error occurred') => {
  const detail = err.response?.data?.detail;

  if (Array.isArray(detail)) {
    // FastAPI validation errors - format as readable messages
    const errorMessages = detail.map(error => {
      const field = error.loc?.[error.loc.length - 1] || 'field';
      return `${field}: ${error.msg}`;
    }).join(', ');
    return errorMessages;
  } else if (typeof detail === 'string') {
    return detail;
  } else {
    return defaultMessage;
  }
};
